module.exports = __webpack_public_path__ + "static/0069-e3878a6940f7f50afb6ddc1ded0bad60.png";